import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { NewWalletAction } from "../../components/actions";
import { NoWallets } from "../../components/banners";
import { Button } from "../../components/common";
import { WalletsTable } from "../../components/tables";
import DashboardLayout from "../../layouts/Dashboard.layout";
import { setVideoAskUrl } from "../../store/reducers/ui";
import { selectWallets } from "../../store/reducers/wallets";

export const Wallets: FC = () => {
  const wallets = useSelector(selectWallets);
  const dispatch = useDispatch();

  // Video guide
  useEffect(() => {
    dispatch(setVideoAskUrl("https://www.videoask.com/fvxuz3dxi"));

    return () => {
      dispatch(setVideoAskUrl(null));
    };
  }, [dispatch]);

  const cryptoWallets = wallets.filter(({ address }) => !!address);

  const NewWalletBtn = (
    <NewWalletAction>
      {(action) => (
        <Button
          className="w-full md:w-auto"
          onClick={action}
          variant={Button.variant.TEMPTING}
        >
          New Wallet
        </Button>
      )}
    </NewWalletAction>
  );

  return (
    <DashboardLayout title="Wallets" action={NewWalletBtn}>
      {cryptoWallets?.length > 0 ? (
        <WalletsTable data={cryptoWallets} />
      ) : (
        <NoWallets />
      )}
    </DashboardLayout>
  );
};
